import type { AccountThemeId } from 'app/constants/accountThemes';

/**
 * Accent palette per account theme — mirrors `account-themes.css` `--app-accent*`.
 * Used to drive `@azuga-bms/theme` (styled-components) so ADS matches portal chrome.
 */
export type AccountThemePalette = {
  accent: string;
  hover: string;
  muted: string;
  contrast: string;
};

export const ACCOUNT_THEME_COLORS: Record<
  AccountThemeId,
  AccountThemePalette
> = {
  'theme-red': {
    accent: '#cd2027',
    hover: '#b91c22',
    muted: '#fef2f2',
    contrast: '#ffffff',
  },
  'theme-blue': {
    accent: '#2196f3',
    hover: '#1e88e5',
    muted: '#eff6ff',
    contrast: '#ffffff',
  },
  'theme-monochrome': {
    accent: '#9e9e9e',
    hover: '#757575',
    muted: '#f5f5f5',
    contrast: '#ffffff',
  },
  'theme-teal': {
    accent: '#009688',
    hover: '#00897b',
    muted: '#f0fdfa',
    contrast: '#ffffff',
  },
  'theme-green': {
    accent: '#8bc34a',
    hover: '#7cb342',
    muted: '#f7fee7',
    contrast: '#ffffff',
  },
  'theme-deep-green': {
    accent: '#007853',
    hover: '#006847',
    muted: '#ecfdf5',
    contrast: '#ffffff',
  },
  'theme-orange': {
    accent: '#ff9800',
    hover: '#fb8c00',
    muted: '#fff7ed',
    contrast: '#ffffff',
  },
  'theme-blue-grey': {
    accent: '#607d8b',
    hover: '#546e7a',
    muted: '#f1f5f9',
    contrast: '#ffffff',
  },
  'theme-purple': {
    accent: '#673ab7',
    hover: '#5e35b1',
    muted: '#f5f3ff',
    contrast: '#ffffff',
  },
  'theme-indigo': {
    accent: '#3f51b5',
    hover: '#3949ab',
    muted: '#eef2ff',
    contrast: '#ffffff',
  },
  'theme-tangaroa': {
    accent: '#0a2240',
    hover: '#081c33',
    muted: '#e2e8f0',
    contrast: '#ffffff',
  },
  'theme-white': {
    accent: '#212121',
    hover: '#424242',
    muted: '#f5f5f5',
    contrast: '#ffffff',
  },
  'theme-emerald': {
    accent: '#3a9017',
    hover: '#285d17',
    muted: '#effde8',
    contrast: '#ffffff',
  },
};
